import React, { useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Box,
  Button,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "../../iamges/hamburger.png";
import CloseIcon from "../../iamges/close.png";
import { useTheme } from "@mui/material/styles";
import { useLocation, Link as RouterLink } from "react-router-dom";
import "./header.scss";

// Nav links for menu
const navLinks = [
  { label: "Rental", path: "/" },
  { label: "Move & More", path: "/homeowner" },
  { label: "About us", path: "/about" },
  // { label: "Privacy policy", path: "/policy" },
  // { label: "Terms of Service", path: "/terms" },
];

const Header: React.FC = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const location = useLocation();
  const toggleDrawer = () => setDrawerOpen(!drawerOpen);

  const redirectToStore = () => {
    const userAgent = navigator.userAgent || (navigator as any).vendor || "";

    if (/iPhone|iPad|iPod/i.test(userAgent)) {
      window.location.href =
        "https://apps.apple.com/ca/app/homeowner/id6448795356";
      return;
    }

    if (/android/i.test(userAgent)) {
      window.location.href =
        "https://play.google.com/store/apps/details?id=com.arptix.homeowner";
      return;
    }

    window.location.href = "/#download";
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <AppBar
        position='static'
        className={`app-header ${isScrolled ? "scrolled" : ""}`}
        sx={{
          backgroundColor: "transparent",
          boxShadow: "none",
          padding: "0",
        }}>
        <div className='menu-wrapper'>
          <Toolbar
            classes={{ root: "toolbar-wrapper" }}
            sx={{ display: "flex", justifyContent: "space-between", px: 2 }}>
            {/* Logo */}
            <Box
              component={RouterLink}
              to='/'
              sx={{
                display: "flex",
                alignItems: "center",
                textDecoration: "none",
              }}>
              <img
                src='./logo.png'
                alt='Logo'
                style={{ height: isScrolled ? 40 : 58, transition: "0.3s" }}
              />
            </Box>

            {/* Desktop Menu */}
            {!isMobile && (
              <>
                <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
                  {navLinks.map((item) => {
                    const isActive = location.pathname === item.path;

                    return (
                      <Button
                        key={item.label}
                        color='inherit'
                        component={RouterLink}
                        to={item.path}
                        sx={{
                          color: "#000",
                          textTransform: "none",
                          fontFamily: "Plus Jakarta Sans",
                          fontSize: isScrolled ? 14 : 16,
                          fontWeight: isActive ? 900 : 400,
                          transition: "0.3s",
                        }}>
                        {item.label}
                      </Button>
                    );
                  })}
                </Box>
                <Button
                  onClick={redirectToStore}
                  variant='contained'
                  sx={{
                    backgroundColor: "#000",
                    color: "white",
                    borderRadius: 9999,
                    px: 3,
                    fontSize: isScrolled ? 12 : 15,
                    transition: "0.3s",
                    textTransform: "none",
                    py: isScrolled ? 0.75 : 1.75,
                    "&:hover": { backgroundColor: "#333" },
                  }}>
                  Download App
                </Button>
              </>
            )}

            {/* Mobile Menu Icon */}
            {isMobile && (
              <div className='pr-3'>
                <Button
                  variant='contained'
                  onClick={redirectToStore}
                  sx={{
                    backgroundColor: "#000",
                    color: "white",
                    borderRadius: 9999,
                    px: 2,
                    py: 0.5,
                    marginRight: 1,
                    textTransform: "capitalize",
                    "&:hover": { backgroundColor: "#333" },
                  }}>
                  Download App
                </Button>
                <IconButton edge='end' color='inherit' onClick={toggleDrawer}>
                  <img src={MenuIcon} alt='MenuIcon' className='menu-icon' />
                </IconButton>
              </div>
            )}
          </Toolbar>
        </div>
      </AppBar>

      {/* Drawer for mobile */}
      <Drawer anchor='right' open={drawerOpen} onClose={toggleDrawer}>
        <Box sx={{ width: 250 }} onClick={toggleDrawer}>
          <IconButton sx={{ m: 1 }} aria-label='Close drawer'>
            <img src={CloseIcon} alt='CloseIcon' className='menu-icon' />
          </IconButton>
          <List>
            {navLinks.map((item) => {
              const isActive = location.pathname === item.path;
              return (
                <ListItem
                  key={item.label}
                  component={RouterLink}
                  to={item.path}
                  sx={{
                    textDecoration: "none",
                  }}>
                  <ListItemText>
                    <span style={{ fontWeight: isActive ? 900 : 400 }}>
                      {item.label}
                    </span>
                  </ListItemText>
                </ListItem>
              );
            })}
            <ListItem>
              <Button
                variant='contained'
                fullWidth
                onClick={redirectToStore}
                sx={{
                  backgroundColor: "#000",
                  color: "white",
                  borderRadius: 2,
                  textTransform: "none",
                  mt: 1,
                }}>
                Download App
              </Button>
            </ListItem>
          </List>
        </Box>
      </Drawer>
    </>
  );
};

export default Header;
